import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import * as React from 'react';
export default {
  OpenInNewIcon,
  React
};